import React, { useState } from 'react';
import PrimaryButton from './Button/PrimaryButton';
import DateInput from './Input/DateInput';
import { getActiveMembersForCSV } from '../services/dashboard.service';
import { toTitleCase } from '../utils/formatter';
import { toast } from 'react-toastify';

const PrintCSVMembercard = () => {
  const [validAt, setValidAt] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const exportToCSV = (data, filename) => {
    console.log('poli poli',data)
    const csvHeaders = [
      'ID',
      'KTA Number',
      'Full Name',
      'Valid At',
      'Expired At',
      'Member Card',
      'Korwil',
      'Shirt Size',
      'Activated',
      'Path Profile'
    ];

    const csvContent = [
      csvHeaders.join(','),
      ...data.map(row => [
        row.id,
        row.ktaNumber,
        `"${toTitleCase(row.fullname)}"`,
        row.validAt,
        row.expiredAt,
        `"${row.memberCard}"`,
        `"${row.korwil || ''}"`,
        `"${row.shirtSize || ''}"`,
        row.activated,
        `"${row.profileImage || ''}"`,
      ].join(','))
    ].join('\n');

    console.log(csvHeaders)
    console.log(csvContent)

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePrintCSV = async () => {
    if (isLoading) {
      return;
    }
    if (!validAt) {
      toast.error('Please select a valid date.');
      return;
    }

    try {
      setIsLoading(true);
      const result = await getActiveMembersForCSV(validAt);
      
      if (result.data && result.data.length > 0) {
        const filename = `active-members-${validAt}.csv`;
        exportToCSV(result.data, filename);
        toast.success(`CSV file downloaded successfully. Total records: ${result.total}`);
      } else {
        toast.warning('No data found for the selected date.');
      }
    } catch (error) {
      console.error('Error exporting CSV:', error);
      toast.error('Failed to export CSV. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <label
        htmlFor="valid-date"
        className="text-sm text-[#838489] whitespace-nowrap"
      >
        Valid Date
      </label>
      <DateInput
        id="valid-date"
        value={validAt}
        onChange={setValidAt}
        disabled={isLoading}
      />
      <PrimaryButton onClick={handlePrintCSV} loading={isLoading}>
        {isLoading ? 'Menyiapkan...' : 'Print CSV Membercard'}
      </PrimaryButton>
    </div>
  );
};

export default PrintCSVMembercard;
